import { ListType } from 'types/selectbox';

export const getInquiryTypes = (t: (key: string) => string): ListType[] => [
  { value: 0, label: t('contactUs.inquiryType.use') },
  { value: 1, label: t('contactUs.inquiryType.share') },
  { value: 2, label: t('contactUs.inquiryType.estimate') },
  { value: 3, label: t('contactUs.inquiryType.press') },
  { value: 4, label: t('contactUs.inquiryType.other') }
];

export const CountryList: ListType[] = [
  { value: 1, label: 'South Korea' },
  { value: 2, label: 'Country 2' },
  { value: 3, label: 'Country 3' },
  { value: 4, label: 'Country 4' }
];

/*
export const inquiryTypes: ListType[] = [
  { value: 1, label: 'Use a ground station' },
  { value: 2, label: 'Share a ground station' },
  { value: 3, label: 'Estimate Inquiry' },
  { value: 4, label: 'Make a press inquiry' },
  { value: 5, label: 'Other' }
];
*/